import { observable, action } from 'mobx';
import { db, firebase } from '../firebase';
import history from '../components/history';

// =====================================
// CONSTS
import { Statuses } from '../const/Statuses';

// =====================================
// STORES
import { loginStore } from './LoginStore';

// =====================================
// MODELS
import { User } from '../models/User';

export interface ICommonStore {
    user: User;
    isLoading: boolean;
    isUserLoggedIn: boolean;

    init(): void;
    getOrderStatus(statusName: string): string;
    getOrderStatusColor(statusName: string): string;
    getOrderStatusIcon(statusName: string): string;
    paddy(num, padlen, padchar);
    reset(): void;
}

export class CommonStore implements ICommonStore {
    constructor() {
        this.user = new User();
        this.isLoading = true;
    }

    @observable user: User;
    @observable isLoading: boolean;
    @observable isUserLoggedIn: boolean;

    @action init = (): void => {
        firebase.auth().onAuthStateChanged(async (currentUser: firebase.User) => {
            if (loginStore.type === "login" || loginStore.type === "register") return;
            commonStore.isUserLoggedIn = (commonStore.getLocalStorageItem("isUserLoggedIn") === "true");
            if (currentUser && commonStore.isUserLoggedIn) {
                this.isUserSalesRep(currentUser.uid);
            }
        });
    }

    isUserSalesRep = async (userId) => {

        let userSnap = await db.collection("users").doc(userId).get();
        if (userSnap.exists) {
            this.user = userSnap.data() as any;
            if (commonStore.user.orgId !== "") {
                let userInOrganizationSnap = await loginStore.getUserFromOrganizationColl(commonStore.user.id, commonStore.user.orgId);
                if (userInOrganizationSnap.exists) {
                    let userInOrganization = userInOrganizationSnap.data();
                    this.user = userInOrganization as any;
                    if (userInOrganization.isSalesRep) {
                        // if (this.user.id === "") {
                        //     this.user.id = this.getSessionItem("userId");
                        // }

                        //this.getLoggedInUserData();
                        this.isUserLoggedIn = true;

                        if (!this.getLocalStorageItem("userId")) {
                            this.setLocalStorageItem("userId", this.user.id);
                        }
                        this.isLoading = false;
                    } else {
                        this.userDoesNotExist();
                    }
                } else {
                    this.userDoesNotExist();
                }
            } else {
                this.userDoesNotExist();
            }
        } else {
            this.userDoesNotExist();
        }

    }

    @action userDoesNotExist = () => {
        this.isUserLoggedIn = false;
        this.isLoading = false;
        history.push('/');
    }

    @action getLoggedInUserData = async () => {
        try {
            const doc = await db.collection('users')
                //.doc('G20jF1qGNrhLavGvDjcKUdAg7vs2')
                .doc(this.user.id)
                .get();

            this.user = doc.data() as any;
            if (!this.getLocalStorageItem("userId")) {
                this.setLocalStorageItem("userId", this.user.id);
            }
            this.isLoading = false;
        }
        catch (error) {
            this.isLoading = false;
            console.log("Error getting user data:", error);
        };
    }

    @action getOrderStatus = (statusName: string): string => {
        let status: string = "";

        switch (statusName) {
            case Statuses.INITIALIZED:
                status = "Započeto";
                break;
            case Statuses.SUBMITTED:
                status = "Podneto";
                break;
            case Statuses.CANCELED:
                status = "Otkazano";
                break;
            case Statuses.APPROVED:
                status = "Odobreno";
                break;
            case Statuses.SENT_TO_SUPPLIER:
                status = "Poslato dobavljaču";
                break;
            case Statuses.RECEIVED:
                status = "Primljeno";
                break;
            case Statuses.NOT_DELIVERED:
                status = "Nije isporučeno";
                break;
            case Statuses.PENDING:
                status = "U obradi";
                break;
            case Statuses.MODIFIED:
                status = "Izmenjeno";
                break;
            case Statuses.REJECTED:
                status = "Odbijeno";
                break;
            case Statuses.ACCEPTED:
                status = "Prihvaćeno";
                break;
            case Statuses.IN_PREPARATION:
                status = "U pripremi";
                break;
            case Statuses.PREPARED:
                status = "Pripremljeno";
                break;
            case Statuses.SHIPPED:
                status = "Poslato";
                break;
            case Statuses.RECEIVED_BY_CUSTOMER:
                status = "Isporučeno kupcu";
                break;
            case Statuses.INVOICED:
                status = "Faktursano";
                break;
            default:
                return "-";
        }

        return status;
    }

    @action getOrderStatusColor = (statusName: string): string => {
        let fontColor: string = "";

        switch (statusName) {
            case Statuses.INITIALIZED:
            case Statuses.SUBMITTED:
            case Statuses.SENT_TO_SUPPLIER:
            case Statuses.RECEIVED:
            case Statuses.PENDING:
            case Statuses.IN_PREPARATION:
            case Statuses.PREPARED:
            case Statuses.SHIPPED:
            case Statuses.RECEIVED_BY_CUSTOMER:
            case Statuses.INVOICED:
                fontColor = "#ffa500";
                break;
            case Statuses.NOT_DELIVERED:
            case Statuses.MODIFIED:
                fontColor = "#800080";
                break;
            case Statuses.APPROVED:
            case Statuses.ACCEPTED:
                fontColor = "#008000";
                break;
            case Statuses.CANCELED:
            case Statuses.REJECTED:
                fontColor = "#ca2121";
                break;
            default:
                return "-";
        }

        return fontColor;
    }

    @action getOrderStatusIcon = (statusName: string): string => {
        let iconValue: string = "";

        switch (statusName) {
            case Statuses.INITIALIZED:
                iconValue = "more_horiz";
                break;
            case Statuses.SUBMITTED:
                iconValue = "send";
                break;
            case Statuses.CANCELED:
                iconValue = "cancel";
                break;
            case Statuses.APPROVED:
                iconValue = "check_circle_outline";
                break;
            case Statuses.SENT_TO_SUPPLIER:
                iconValue = "check_circle";
                break;
            case Statuses.RECEIVED:
                iconValue = "call_received";
                break;
            case Statuses.NOT_DELIVERED:
                iconValue = "report_problem";
                break;
            case Statuses.PENDING:
                iconValue = "pause";
                break;
            case Statuses.MODIFIED:
                iconValue = "post_add";
                break;
            case Statuses.REJECTED:
                iconValue = "pan_tool";
                break;
            case Statuses.ACCEPTED:
                iconValue = "done";
                break;
            case Statuses.IN_PREPARATION:
                iconValue = "query_builder";
                break;
            case Statuses.PREPARED:
                iconValue = "battery_full";
                break;
            case Statuses.SHIPPED:
                iconValue = "shopping_cart";
                break;
            case Statuses.RECEIVED_BY_CUSTOMER:
                iconValue = "done_all";
                break;
            case Statuses.INVOICED:
                iconValue = "receipt";
                break;
            default:
                return "-";
        }

        return iconValue;
    }

    setLocalStorageItem = (key: string, value: string): void => {
        localStorage.setItem(key, value);
    }

    getLocalStorageItem = (key: string): string => {
        return localStorage.getItem(key);
    }

    paddy = (num, padlen, padchar?) => {
        var pad_char = typeof padchar !== 'undefined' ? padchar : '0';
        var pad = new Array(1 + padlen).join(pad_char);
        return (pad + num).slice(-pad.length);
    }

    @action reset = (): void => {
        this.user = new User();
        this.isLoading = true;
        this.isUserLoggedIn = false;
    }
}

export let commonStore = new CommonStore();